import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export default function Testimonials() {
  const reviews = [
    { text: "Excellent service and professional execution. They delivered exactly what we needed on time.", author: "Client Feedback", role: "Business Owner" },
    { text: "Highly recommended! The attention to detail and customer support is top-notch.", author: "Rahul Sharma", role: "Project Manager" },
    { text: "Excellent service and professional execution. They delivered exactly what we needed on time.", author: "Client Feedback", role: "Business Owner" },
    { text: "Excellent service and professional execution. They delivered exactly what we needed on time.", author: "Client Feedback", role: "Business Owner" },
    { text: "Excellent service and professional execution. They delivered exactly what we needed on time.", author: "Client Feedback", role: "Business Owner" },
    { text: "Excellent service and professional execution. They delivered exactly what we needed on time.", author: "Client Feedback", role: "Business Owner" },
    { text: "Excellent service and professional execution. They delivered exactly what we needed on time.", author: "Client Feedback", role: "Business Owner" },
    { text: "Excellent service and professional execution. They delivered exactly what we needed on time.", author: "Client Feedback", role: "Business Owner" },
  ];

  return (
    <section className="py-5 bg-light">
      <div className="container">
        {/* Section Heading */}
        <div className="text-center mb-5">
          <span className="text-success fw-bold text-uppercase tracking-wider fs-6">
            Reviews
          </span>
          <h2 className="fw-bold text-dark mt-1">What Our Clients Say</h2>
          <div className="bg-success mx-auto mt-2" style={{ width: "50px", height: "3px" }}></div>
        </div>

        {/* Carousel Container Wrapper */}
        {/* 💡 FIX: Applied w-100 and overflow-hidden to block pagination/track breaking bounds */}
        <div className="pb-4 position-relative w-100 overflow-hidden">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={24}
            slidesPerView={1}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            pagination={{
              clickable: true,
              el: ".custom-swiper-pagination",
            }}
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            className="mySwiper"
          >
            {reviews.map((item, index) => (
              <SwiperSlide key={index} className="h-auto pb-3 px-1"> {/* 💡 Optimization: Swapped m-1 for px-1 to protect shadows */}
                <div className="card h-100 border-0 shadow-sm p-4 rounded-4 bg-white position-relative">
                  <div className="text-success opacity-25 fs-1 position-absolute top-0 end-0 me-3 mt-1">
                    <i className="bi bi-quote"></i>
                  </div>

                  <p className="card-text text-muted fst-italic mb-4" style={{ lineHeight: "1.6" }}>
                    "{item.text}"
                  </p>

                  <div className="mt-auto d-flex align-items-center">
                    <div className="ms-2">
                      <h5 className="mb-0 fw-bold text-dark fs-6">
                        {item.author}
                      </h5>
                      <small className="text-muted">{item.role}</small>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* This target div will receive the styled dots completely outside the slider area */}
          <div className="custom-swiper-pagination d-flex justify-content-center mt-4" />
        </div>
      </div>
    </section>
  );
}
